import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import type { NotificationStatus } from '../../../types'
import { createNotificationCustomStatusReference } from '../utils/referenceValues'

/**
 * Builds active custom status options alphabetically. Prefixed values keep
 * them distinct from the Draft and Closed system-status values used by
 * notification forms.
 */
export function useStatusOptions(statuses: NotificationStatus[]) {
  return useOptions({
    items: statuses
      .filter(({ deleted }) => !deleted)
      .map(createNotificationCustomStatusReference),
    label: 'label',
    sort: 'label',
    tooltip: 'tooltip',
    value: 'value',
  })
}
